import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  box: {
    display: "flex",
    alignItems: "center",
    border: "1px solid #b2b2b2",
    borderRadius: 8,
    padding: theme.spacing(2),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  warning: {
    backgroundColor: "#fff9e8",
  },
  info: {
    backgroundColor: "rgba(233, 233, 233, 0.3)",
  },
  content: {
    display: "flex",
    alignItems: "flex-start",
    flex: "1 1 0",
    minWidth: 0,
  },
  icon: {
    width: 32,
    height: 32,
    flexShrink: 0,
  },
  text: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(0.5),
    flex: "1 1 0",
    minWidth: 0,
    padding: theme.spacing(0, 2),
    color: "#323232",
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
    lineHeight: "25px",
    letterSpacing: "0.15px",
  },
  subtitle: {
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 1.43,
    letterSpacing: "0.17px",
  },
  bold: {
    fontWeight: 700,
  },
  analyzeButton: {
    flexShrink: 0,
    backgroundColor: "#263238",
    color: theme.palette.common.white,
    borderRadius: 2,
    padding: "8px 22px",
    fontSize: 16,
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#1c262b",
      boxShadow: "none",
    },
  },
}));
